import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class OutboxService {

  constructor(public _utilsService: UtilsService,) { }
  createTags(obj) {
    Object.entries(obj || {}).forEach(([key, value]) => {
      if (value === "") {
        let formattedKey = key.toLowerCase().replace(/ /g, "_").replace(/-/g, "_");
        obj[key] = "tag_" + formattedKey;
      }
    });
    return obj
  }
  getResponseMsgs(type: string) {
    if (type == "error") {
      return {
        "1": {
          "title": "Error",
          "text": "Oops! Something went wrong! Help us improve your experience by sending an error report."
        },
        "2": {
          "title": "Error",
          "text": "The application has encountered an unknown error. It doesn't appear to have affected your data, but our technical staff have been automatically notified and will be looking into this with the utmost urgency. Please try after sometime."
        },
        "202": {
          "title": "Error",
          "text": "The Project you are trying to upload the file for does not exist. Please contact system administrator."
        },
        "203": {
          "title": "Error",
          "text": "The Config you are trying to use for file upload does not exist. Please contact system administrator."
        },
        "204": {
          "title": "Error",
          "text": "File with provided extension is not supported. Please try uploading .csv, .xls, .xlsx"
        },
        "205": {
          "title": "Error",
          "text": "File is too large to process. Maximum file size supported is 20 MB."
        },
        "4057": {
          "title": "Error",
          "text": "Uploded file has malicious content. Please scan your file with antivirus software."
        }
      };
    }
    else {
      return {};
    }
  }
  getAfpConfigs(brand_id: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/configs/afp_configs');
    const params: any = {}
    params[URLS_CONST.BRAND_ID] = brand_id
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }
  getTouchpointByText(brand_id: string, key: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/shops/search');
    const params: any = {
      limit: 10,
      page_number: 1,
      txt: key
    }
    params[URLS_CONST.BRAND_ID] = brand_id
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }
  getMultiRequestUploadHistory(brand_id: string, page_number: number) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/infra/status');
    const params: any = {
      file_type: 1,
      job_type: 1,
      limit: 10
    }
    params[URLS_CONST.BRAND_ID] = brand_id
    params['page_number'] = page_number ? page_number : 1
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(params))
  }
  postConfiguration(configData) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/configs/afp_configs');
    return this._utilsService.postAPICall(url, configData, this._utilsService.setHeaderWithParams(''))
  }
  uploadFile(formData: FormData) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/infra/upload');
    return this._utilsService.postAPICall(url, formData, this._utilsService.setHeaderWithParams(''))
  }


  validateUserAnduploadFile(formData: FormData) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/requests/create');
    // const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/infra/upload');
    return this._utilsService.postAPICall(url, formData, this._utilsService.setHeaderWithParams(''))
  }
  // in-progress
  sendRequestFeedback(reqParams){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/request_feedback_for_shop_id');
    const params: any = {}
    params["shopId"] = reqParams.shopId;
    params["is_excluded_from_analytics"] = reqParams.is_excluded_from_analytics;
    params["is_whatsapp_number_same_as_phone_number"] = reqParams.is_whatsapp_number_same_as_phone_number;
    params["name"] = reqParams.name;
    params["notify_channel"] = reqParams.notify_channel;
    params["userEmail"] = reqParams.userEmail;
    params["userPhone"] = reqParams.userPhone;
    params["userWhatsapp"] = reqParams.userWhatsapp;
   
    return this._utilsService.postAPICall(url, params, this._utilsService.setHeaderWithParams(''))
  }
  getListForSentTab(reqParams: any){
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/get_shops_by_brand_id');
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(reqParams))
  }
}
